var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalander(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66683 1.66699V5.00033M11.3335 1.66699V5.00033M8.00016 12.5003H11.3335M1.3335 9.16699H14.6668M4.66683 12.5003H4.75016M3.00016 16.667H13.0002C13.9206 16.667 14.6668 15.9208 14.6668 15.0003V5.00033C14.6668 4.07985 13.9206 3.33366 13.0002 3.33366H3.00016C2.07969 3.33366 1.3335 4.07985 1.3335 5.00033V15.0003C1.3335 15.9208 2.07969 16.667 3.00016 16.667Z",
    stroke: "#A3A3A3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalander);
export default __webpack_public_path__ + "static/media/calander.0f1e3cf52939ab8634b1da4c58e896ae.svg";
export { ForwardRef as ReactComponent };